export default () => {

  if(document.querySelector('.input')){
    let input = document.querySelectorAll('.input');

    const ACTIVE_INPUT = 'active-input';

    input.forEach((input) => {
      input.addEventListener('input', () => {
        if(input.value.length > 0){
          input.classList.add(ACTIVE_INPUT);
        } else {
          input.classList.remove(ACTIVE_INPUT);
        }
      });
    });
  }

  if(document.querySelector('.select')){
    let select = document.querySelectorAll('.select');
    const SELECT_OPENED = 'select-opened';


    select.forEach(select => {
      let selectBtn = select.querySelector('.select__button');
      let selectItems = select.querySelectorAll('.select__item');

      selectBtn.addEventListener('click', () => {
        if(!select.classList.contains(SELECT_OPENED)){
          select.classList.add(SELECT_OPENED);
        } else {
          select.classList.remove(SELECT_OPENED);
        }
      });

      selectItems.forEach((selectItem) => {
        selectItem.addEventListener('click', () => {
          selectBtn.innerText = selectItem.innerText;
          selectBtn.classList.add('has-value');
          selectBtn.setAttribute('data-value', selectItem.getAttribute('data-value'));
          select.classList.remove(SELECT_OPENED);
        });
      });

    });


    document.addEventListener('click', (e) => {
      let target = e.target;
      select.forEach(select => {
        let selectTarget = target == select || select.contains(target);
        let selectIsOpened = select.classList.contains('select-opened');
        if(!selectTarget && selectIsOpened){
          select.classList.remove(SELECT_OPENED);
        }
      });
    });
  }


}